const INVALID_MCP_SERVER_URL_MESSAGE =
  "Invalid MCP server URL. Please include a full URL starting with https://";

type ZodIssueLike = {
  path?: unknown;
  message?: unknown;
};

const isIssueForServerUrl = (issue: ZodIssueLike): boolean => {
  if (!Array.isArray(issue.path)) {
    return false;
  }

  return issue.path.includes("serverUrl");
};

const isInvalidUrlIssueMessage = (message: string): boolean => {
  return /invalid\s+url/i.test(message) || /valid\s+url/i.test(message);
};

export const isValidHttpsMcpServerUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const getMcpAddConnectionErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  const response =
    typeof error === "object" && error !== null
      ? Reflect.get(error, "response")
      : undefined;
  const responseData =
    typeof response === "object" && response !== null
      ? Reflect.get(response, "data")
      : undefined;

  if (typeof responseData?.message === "string" && responseData.message) {
    return responseData.message;
  }

  if (Array.isArray(responseData)) {
    const serverUrlIssue = responseData.find((issue: ZodIssueLike) =>
      isIssueForServerUrl(issue)
    );
    const issueMessage =
      typeof serverUrlIssue?.message === "string"
        ? serverUrlIssue.message
        : null;

    if (issueMessage && isInvalidUrlIssueMessage(issueMessage)) {
      return INVALID_MCP_SERVER_URL_MESSAGE;
    }
  }

  return fallbackMessage;
};

export { INVALID_MCP_SERVER_URL_MESSAGE };
